import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { AppProvider } from "./context/AppContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<>
		{/* <AppProvider> */}
			<div className="root-content position-relative" >
				<App />
				   <ToastContainer position="top-right" autoClose={3000} />
			</div>
		{/* </AppProvider> */}
	</>
);
